export default "__VITE_ASSET__ByD_shht__"